import { cn } from '@components/shadcn/utils';
import type { SVGProps } from 'react';

export const CheckCircleIcon = ({
  fill,
  size = 24,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    className={cn('inline-block', props.className)}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 14.1701L16.59 7.58008L18 9.00008L10 17.0001L6 13.0001L7.41 11.5901L10 14.1701Z"
      fill={fill ?? '#19A04B'}
    />
  </svg>
);
